export default __webpack_public_path__ + "static/media/online_platform.1c19a05a.png";